import { render, staticRenderFns } from "./rule_setting_index.vue?vue&type=template&id=009c5fde&scoped=true"
import script from "./rule_setting_index.vue?vue&type=script&lang=js"
export * from "./rule_setting_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009c5fde",
  null
  
)

export default component.exports